<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger v-if="!useMobileLayout" class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-button
      v-if="showLayoutPreviewToggle"
      type="text"
      size="small"
      class="layout-preview-toggle"
      :title="layoutPreviewToggleTitle"
      @click="toggleLayoutPreview">
      <i :class="layoutPreviewMode === 'mobile' ? 'el-icon-monitor' : 'el-icon-mobile-phone'"></i>
      <span class="layout-preview-toggle-label">{{ layoutPreviewToggleLabel }}</span>
    </el-button>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <span class="user-name" :title="displayUserName">{{ displayUserName }}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item @click.native="goHome">首页</el-dropdown-item>
        <el-dropdown-item @click.native="goProfile">我的</el-dropdown-item>
        <el-dropdown-item divided @click.native="logout">
          退出
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { hasSuperAdminRole } from '@/utils/privilegedRoleAccess'
import { LAYOUT_PREVIEW_MOBILE } from '@/utils/layoutPreviewMode'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'nickName',
      'roles',
      'openEmbedMode',
      'layoutPreviewMode',
      'device',
      'useMobileLayout'
    ]),
    showLayoutPreviewToggle() {
      if (this.openEmbedMode) return false
      if (this.device === 'mobile') return false
      return hasSuperAdminRole(this.roles || [])
    },
    layoutPreviewToggleLabel() {
      return this.layoutPreviewMode === LAYOUT_PREVIEW_MOBILE ? 'PC 样式' : '移动端样式'
    },
    layoutPreviewToggleTitle() {
      return this.layoutPreviewMode === LAYOUT_PREVIEW_MOBILE
        ? '切换为 PC 样式（默认）'
        : '切换为移动端样式预览'
    },
    displayUserName() {
      const n = this.nickName && String(this.nickName).trim()
      if (n) return n
      const u = this.name && String(this.name).trim()
      return u || '用户'
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    toggleLayoutPreview() {
      if (!this.showLayoutPreviewToggle) return
      this.$store.dispatch('ToggleLayoutPreview')
    },
    goHome() {
      this.$router.push({ path: '/' }).catch(() => {})
    },
    goProfile() {
      this.$router.push({ path: '/profile' }).catch(() => {})
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .layout-preview-toggle {
    position: absolute;
    right: 200px;
    top: 0;
    height: 50px;
    padding: 0 8px;
    color: #606266;
    font-size: 13px;
    .layout-preview-toggle-label {
      margin-left: 4px;
    }
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-name {
        display: inline-block;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue